import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { FC } from 'react';
import { MdOpenInNew, MdPictureAsPdf } from 'react-icons/md';

import { DialogTitle } from '../../dialog-title';

type Props = {
  open: boolean;
  src: string;
  name?: string;
  onClose: () => void;
};

/**
 * Full-screen PDF lightbox — the PDF equivalent of ImagePreviewDialog. Renders
 * the document inline via an <iframe> (the browser's native PDF viewer) with an
 * "Open in new tab" escape hatch for environments that don't embed PDFs inline
 * (e.g. iOS Safari). Driven globally by usePdfPreviewService / PdfPreviewProvider.
 */
export const PdfPreviewDialog: FC<Props> = ({ open, src, name, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle icon={<MdPictureAsPdf />} onClose={onClose}>
        {name ?? 'PDF Preview'}
      </DialogTitle>
      <DialogContent sx={{ p: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
          <Button
            component="a"
            href={src}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            variant="soft"
            startIcon={<MdOpenInNew />}
          >
            Open in new tab
          </Button>
        </Box>
        <Box
          component="iframe"
          src={src}
          title={name ?? 'PDF Preview'}
          sx={{ width: '100%', height: '80vh', border: 'none', display: 'block', borderRadius: '8px' }}
        />
      </DialogContent>
    </Dialog>
  );
};
